import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as moment from 'moment';
import formatAmount from '../shared/format_amount';

class PriceGuideTransaction extends React.Component {
  static propTypes = {
    transaction: PropTypes.object.isRequired,
  };

  render() {
    return (
      <tr className="transaction">
        <td>{moment(this.props.transaction.date).format('MM/DD/YYYY')}</td>
        <td>{this.props.transaction.condition}</td>
        <td><span className="price-history-table-price">{formatAmount(this.props.transaction.price_final)}</span></td>
      </tr>
    );
  }
}

export default PriceGuideTransaction;



// WEBPACK FOOTER //
// ./javascripts/components/listing_form/price_guide_transaction.jsx